// src/api/userApi.js
import api from "../configs/axiosConfig";

// GET /user/profile
export async function getProfile(userID) {
  const response = await api.get(`/user/profile/${userID}`);
  return response.data;
}

// POST /user/change-password
export async function changePassword(payload, userId) {
  // payload: { current_password, new_password }

  const response = await api.post(`/auth/change-password/${userId}`, payload);
  return response.data;
}


// POST /account/upgrade/:user_id
export async function upgradeAccount(userId) {
  const response = await api.get(`/user/account_activation_request/${userId}`);
  return response.data;
}

